import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshirdicabs() {



  const cardData =
  {
    keyword: 'Mumbai to shirdi cabs',
    heading: 'Sai Trupti Cabs: Mumbai to shirdi cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Mumbai to Shirdi cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Mumbai, courteous service, and safe, smooth driving all the way to Shirdi. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Mumbai to Shirdi convenient, affordable, and worry-free.',

    top: 'Top Places to Visit in Shirdi with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shri Sai Baba Samadhi Mandir",
    "description": "Shri Sai Baba Samadhi Mandir is the spiritual heart of Shirdi and one of the most revered pilgrimage sites in India. Built at the place where Sai Baba attained samadhi in 1918, the temple attracts millions of devotees from across the world. The white marble sanctum houses Sai Baba’s idol, radiating peace, faith, and devotion. Daily aartis and disciplined darshan arrangements create a deeply moving spiritual experience. The temple stands as a symbol of unity, compassion, and unconditional faith."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is a sacred mosque where Sai Baba spent a significant part of his life. It was here that he lit the sacred dhuni (holy fire), whose ash is believed to have healing powers. The simple stone structure preserves Baba’s way of life and teachings of humility and service. Devotees feel a deep spiritual connection within its walls. Dwarkamai remains a powerful reminder of Sai Baba’s message of love and equality."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is an important historical and spiritual site where Sai Baba used to sleep on alternate nights. The procession of Baba’s palki from Dwarkamai to Chavadi is still ceremonially remembered. The site preserves Baba’s wooden bed, oil lamps, and personal items. Its quiet atmosphere encourages reflection and devotion. Chavadi connects devotees closely to Sai Baba’s daily life and simple living."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan marks the place where Sai Baba was first seen meditating under a neem tree. Considered one of the holiest spots in Shirdi, it holds deep spiritual significance for devotees. The neem tree is believed to have miraculous healing properties. People offer prayers and light incense seeking blessings and guidance. Gurusthan symbolizes the beginning of Sai Baba’s divine journey in Shirdi."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a peaceful garden where Sai Baba spent time meditating and watering plants. The garden features the sacred Nanda Deep, a lamp that has been continuously burning since Baba’s time. Its calm environment offers visitors a place for quiet contemplation. The simplicity of the surroundings reflects Baba’s teachings. Lendi Baug is a serene retreat for devotees seeking inner peace."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple holds historical importance as the place where Sai Baba was welcomed into Shirdi by Mhalsapati, who addressed him as ‘Sai’. Dedicated to Lord Khandoba, the temple is a small yet spiritually significant shrine. Devotees visit to honor the beginning of Sai Baba’s acceptance by the village. The temple blends local tradition with Sai Baba’s legacy. It is an essential stop in the Shirdi pilgrimage circuit."
  },
  {
    "title": "Sai Teerth Devotional Theme Park",
    "description": "Sai Teerth is India’s first devotional theme park, offering a unique blend of spirituality and technology. Through 3D shows, laser presentations, and immersive storytelling, it brings Sai Baba’s life and teachings to life. Attractions like Teerth Yatra and Shirdi Darshan appeal to families and younger visitors. The park enhances spiritual learning in an engaging way. It adds a modern dimension to Shirdi’s devotional experience."
  },
  {
    "title": "Wet N Joy Water Park (Nearby Attraction)",
    "description": "Located close to Shirdi, Wet N Joy Water Park offers a refreshing recreational option for families and tourists. With thrilling water rides, wave pools, and relaxing zones, it provides a fun break from temple visits. The park is well-maintained and suitable for all age groups. It adds entertainment value to a spiritual trip. Wet N Joy balances devotion with leisure in Shirdi."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Shani Shingnapur, located near Shirdi, is a unique village famous for its open-door houses and the powerful shrine of Lord Shani. The village is known for its strong belief in divine protection and justice. Devotees visit to seek relief from Saturn-related astrological challenges. The temple’s spiritual energy and unique social system fascinate visitors. It is one of the most popular nearby pilgrimages from Shirdi."
  },
  {
    "title": "Abdul Baba Cottage",
    "description": "Abdul Baba Cottage is a small but significant site dedicated to Sai Baba’s close disciple, Abdul Baba. The place preserves memories of Baba’s teachings on devotion, service, and unity beyond religion. Devotees visit to pay respect and seek spiritual inspiration. Its quiet and humble setting reflects the simplicity of Baba’s followers. The cottage adds depth to the spiritual journey of Shirdi."
  }
],



  "services": [
    {
      "name": "Mumbai to Shirdi Cab",
      "description": "Reliable cab service from Mumbai to Shirdi offering a smooth and comfortable long-distance journey of approximately 240–260 km. Choose from AC and non-AC vehicles driven by experienced chauffeurs familiar with the route. Includes door-to-door pickup, luggage assistance, rest stops on request, transparent pricing, and a safe travel experience ideal for pilgrims, families, and senior citizens."
    },
    {
      "name": "Mumbai to Shirdi Taxi",
      "description": "Professional taxi service from Mumbai to Shirdi providing point-to-point travel with well-maintained vehicles, courteous drivers, and flexible pickup locations. Perfect for Sai Baba devotees seeking a stress-free, comfortable, and timely journey with AC comfort and reliable service."
    },
    {
      "name": "Mumbai to Shirdi Taxi Service",
      "description": "Dedicated taxi service from Mumbai to Shirdi designed for pilgrim and leisure travel. Features include clean AC cars, experienced drivers, flexible departure times, assistance for elderly passengers, and transparent taxi charges with no hidden costs."
    },
    {
      "name": "Mumbai to Shirdi One Way Cab",
      "description": "Cost-effective one-way cab service from Mumbai to Shirdi allowing travelers to pay only for a single journey. Ideal for pilgrims and solo travelers, this service offers AC/non-AC vehicles, professional drivers, luggage support, and straightforward pricing."
    },
    {
      "name": "Mumbai to Shirdi Round Trip Cab",
      "description": "Round-trip cab service from Mumbai to Shirdi perfect for devotees planning a return journey the same day or after an overnight stay. Includes driver allowance, flexible return scheduling, comfortable vehicles, and economical round-trip cab fares."
    },
    {
      "name": "Mumbai to Shirdi Innova Cab",
      "description": "Spacious Innova cab service from Mumbai to Shirdi offering superior comfort, ample legroom, and generous luggage space. Ideal for families and groups traveling together, with AC comfort, smooth suspension, and experienced long-route drivers."
    },
    {
      "name": "Mumbai to Shirdi Innova Crysta Cab",
      "description": "Premium Innova Crysta cab from Mumbai to Shirdi featuring luxury seating, enhanced ride quality, powerful performance, and AC comfort. Best suited for VIP pilgrims, corporate travelers, and families seeking a premium travel experience."
    },
    {
      "name": "Mumbai to Shirdi AC Cab",
      "description": "AC cab service from Mumbai to Shirdi ensuring a cool, comfortable, and relaxed journey throughout the trip. Includes professional chauffeurs, clean interiors, smooth driving, and reliable service for long-distance religious travel."
    },
    {
      "name": "Mumbai Airport to Shirdi Taxi",
      "description": "Convenient taxi service from Mumbai Airport to Shirdi with timely pickups, flight-delay coordination, and direct drop at your destination. Ideal for outstation travelers and devotees arriving by air, offering AC vehicles and hassle-free transfers."
    },
    {
      "name": "Cab from Mumbai Airport to Shirdi",
      "description": "Airport pickup cab from Mumbai to Shirdi providing seamless transfers with professional drivers, luggage handling, AC comfort, and transparent fares. Designed for a smooth transition from airport arrival to Shirdi temple visit."
    },
    {
      "name": "Taxi from Shirdi to Mumbai",
      "description": "Reliable return taxi service from Shirdi to Mumbai with flexible pickup timing, comfortable vehicles, and experienced drivers. Ideal for pilgrims completing their darshan and returning safely to Mumbai."
    },
    {
      "name": "Mumbai to Shani Shingnapur Cab",
      "description": "Cab service from Mumbai to Shani Shingnapur offering comfortable long-distance travel for devotees visiting the famous Shani temple. Includes AC vehicles, professional drivers, flexible schedules, and the option to combine Shirdi and Shani Shingnapur trips."
    },
    {
      "name": "Mumbai to Shani Shingnapur Taxi",
      "description": "Taxi service from Mumbai to Shani Shingnapur designed for religious travelers seeking safe, reliable, and comfortable transport. Features experienced chauffeurs, clean vehicles, and transparent taxi pricing."
    },
    {
      "name": "Mumbai to Shirdi Cab Booking",
      "description": "Easy Mumbai to Shirdi cab booking service with multiple vehicle options, flexible pickup points, and instant confirmation. Ideal for advance planning of pilgrim trips, family travel, and group journeys."
    },
    {
      "name": "Mumbai to Shirdi Online Cab Booking",
      "description": "Book your Mumbai to Shirdi cab online with secure payments, transparent pricing, real-time booking confirmation, and a choice of vehicles including Sedan, SUV, and Innova for a hassle-free travel experience."
    },
    {
      "name": "Mumbai to Shirdi Car Rental",
      "description": "Car rental service from Mumbai to Shirdi offering chauffeur-driven vehicles for long-distance comfort. Includes flexible rental packages, AC cars, professional drivers, and cost-effective pricing for pilgrimage travel."
    },
    {
      "name": "Mumbai to Shirdi Car Hire",
      "description": "Chauffeur-driven car hire from Mumbai to Shirdi suitable for families, elderly pilgrims, and group travel. Features include clean vehicles, experienced drivers, luggage support, and flexible travel plans."
    },
    {
      "name": "Mumbai to Shirdi Return Taxi Fare",
      "description": "Economical return taxi fare options from Mumbai to Shirdi covering round-trip travel, driver allowance, and vehicle charges. Ideal for planned darshan visits with same-day or next-day return."
    },
    {
      "name": "Taxi Service from Mumbai to Shirdi",
      "description": "Trusted taxi service from Mumbai to Shirdi focusing on safety, comfort, and punctuality. Perfect for pilgrimage travel with professional chauffeurs, well-maintained cars, and transparent taxi charges."
    }
  ],
  "tableData": [
    ["Mumbai to Shirdi Cab", "Mumbai to Shirdi Taxi"],
    ["Mumbai to Shirdi Taxi Service", "Mumbai to Shirdi One Way Cab"],
    ["Mumbai to Shirdi Round Trip Cab", "Mumbai to Shirdi Innova Cab"],
    ["Mumbai to Shirdi Innova Crysta Cab", "Mumbai to Shirdi AC Cab"],
    ["Mumbai Airport to Shirdi Taxi", "Cab from Mumbai Airport to Shirdi"],
    ["Taxi from Shirdi to Mumbai", "Mumbai to Shani Shingnapur Cab"],
    ["Mumbai to Shani Shingnapur Taxi", "Mumbai to Shirdi Cab Booking"],
    ["Mumbai to Shirdi Online Cab Booking", "Mumbai to Shirdi Car Rental"],
    ["Mumbai to Shirdi Car Hire", "Mumbai to Shirdi Return Taxi Fare"],
    ["Taxi Service from Mumbai to Shirdi", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Shirdi Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services from Mumbai to Shirdi — ideal for pilgrimage trips, family travel, and senior citizens."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one-way fares from Mumbai to Shirdi start from approximately ₹3,000–₹4,500 for sedans, with SUVs and premium car options available at reasonable rates."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or premium cars to suit your group size, luggage needs, and comfort preferences for the Mumbai → Shirdi route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are experienced with the Mumbai to Shirdi highway route, ensuring a safe, smooth, and peaceful journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups anywhere in Mumbai and drop-offs directly at Shirdi hotels, temples, and nearby accommodations."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and equipped with essential amenities for a comfortable and hygienic long-distance ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, travel assistance, or route planning for your Mumbai to Shirdi cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Mumbai to Shirdi cab easily through a call, WhatsApp, or our website — with instant confirmation and quick vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Mumbai to Shirdi cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable cab services from Mumbai to Shirdi for one-way, round-trip, and pilgrimage travel.',
  },
  {
    question: 'How can I book a Mumbai to Shirdi cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Mumbai to Shirdi cab through our website, mobile app, WhatsApp, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Mumbai to Shirdi?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, tempo travellers, and luxury cabs for Mumbai to Shirdi travel.',
  },
  {
    question: 'Are the drivers experienced for Mumbai to Shirdi trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance and pilgrimage routes like Mumbai to Shirdi.',
  },
  {
    question: 'Can I hire a cab from Mumbai to Shirdi for senior citizens?',
    answer: 'Yes, our Mumbai to Shirdi cab service is ideal for senior citizens, families, and group pilgrimage travel.',
  },
  {
    question: 'Is the Mumbai to Shirdi cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Mumbai to Shirdi trips.',
  },
  {
    question: 'What are the Mumbai to Shirdi cab fares?',
    answer: 'Our cab fares start from approximately ₹3,000 for sedans and ₹4,500–₹6,500 for SUVs and premium vehicles, depending on travel requirements.',
  },
  {
    question: 'What payment options are accepted for Mumbai to Shirdi cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Mumbai to Shirdi cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'Is customer support available during the Mumbai to Shirdi cab ride?',
    answer: 'Yes, our 24×7 customer support team is available throughout your Mumbai to Shirdi cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Kulkarni',
    feedback: 'We booked a Mumbai to Shirdi cab with Sai Trupti Cabs. Very comfortable journey and the driver was polite and helpful.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Joshi',
    feedback: 'Excellent Mumbai to Shirdi cab service. Clean vehicle, on-time pickup, and smooth darshan trip.',
    rating: 5,
  },
];














































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Shirdi Cab Service",
  "image": "https://saitrupticabs.com/assets/images/mumbai-to-shirdi-cab.jpg",
  "description": "Sai Trupti Cabs offers Mumbai to Shirdi cab service for Sai Baba darshan with one way taxi, round trip cabs, sedan, SUV, Ertiga and Innova Crysta options. Book affordable outstation cabs with professional drivers, 24x7 service and safe, comfortable pilgrimage travel.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "11240"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/mumbai-to-shirdi-cab",
    "itemCondition": "https://schema.org/NewCondition"
  }
};








  return (
    <div>
      <Helmet>
  <title>Mumbai to Shirdi Cab | Sai Baba Darshan Taxi ₹3499 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Mumbai to Shirdi cab for Sai Baba darshan at ₹3499 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe and comfortable pilgrimage cab service 24x7." 
  />

  <meta 
    name="keywords" 
    content="mumbai to shirdi cab, mumbai to shirdi taxi, mumbai to shirdi cab service, sai baba darshan cab mumbai, mumbai to shirdi one way cab, mumbai to shirdi taxi fare, mumbai to shirdi innova crysta, mumbai to shirdi ertiga cab, mumbai to shirdi sedan cab, cheap mumbai to shirdi cab, best cab service mumbai to shirdi, mumbai to shirdi drop taxi, mumbai to shirdi round trip cab, shirdi darshan cab booking mumbai" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoshirdicabs;